import { useContext } from "react";

import { ModalContext } from "utils/context/modal";

export const useModalContext = () => useContext(ModalContext);
